export enum RadioButton {
  INVESTISSEMENT_AIR = 'invesAir',
  ABONNEMENT_AIR = 'aboAir',
  INVESTISSEMENT_GEO = 'invesGeo'
}